var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linejoin:round;stroke-width:2px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "438-Cloud Arrow Down",
    id: "_438-Cloud_Arrow_Down"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,20h6a4,4,0,0,0,0-8,4,4,0,0,0-1.08.17A9,9,0,1,0,8,10.44,5,5,0,1,0,6,20h5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16,
    x2: 16,
    y1: 30,
    y2: 16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "21 25 16 30 11 25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownArrow);
export default __webpack_public_path__ + "static/media/cloud-down-arrow.402cb8ff8a319326c4b6c1c2836ca957.svg";
export { ForwardRef as ReactComponent };